import { Action } from 'redux';
import { ErrorAction } from '@sonar-software/xuder';

export enum ApplicationActionType {
	HardReset = 'hardReset',
	Reset = 'reset',
	ResetComplete = 'resetComplete',
	SoftReset = 'softReset'
}

export type HardResetApplication = Action<ApplicationActionType>;
export type ResetApplication = Action<ApplicationActionType>;
export type ResetApplicationComplete = Action<ApplicationActionType>;
export type SoftResetApplication = Action<ApplicationActionType>;

export type ApplicationActions =
	| ErrorAction
	| HardResetApplication
	| ResetApplication
	| ResetApplicationComplete
	| SoftResetApplication;

export function hardResetApplication(): HardResetApplication {
	return { type: ApplicationActionType.HardReset };
}

export function resetApplication(): ResetApplication {
	return { type: ApplicationActionType.Reset };
}

export function resetApplicationComplete(): ResetApplicationComplete {
	return { type: ApplicationActionType.ResetComplete };
}

export function softResetApplication(): SoftResetApplication {
	return { type: ApplicationActionType.SoftReset };
}
